module.exports = __webpack_public_path__ + "img/dark-pit-min.335f2bbb.png";